export default __webpack_public_path__ + "static/jobbox-2-a-ff06a7038616797d7ad0f5aa3f25883b.webp";